// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3q_JL","signatureBlock":"Footer_signatureBlock__3uVHN","signature":"Footer_signature__2e7aV"};